import type { ReactNode } from 'react';

import { AccessStatePage } from '@/components/shared/AccessState';

import { useNotificationSummary } from './useNotifications';

/**
 * Route gate of /notifications and /notification-settings. No permission: every signed-in
 * user has notifications (the routes sit behind the signed-in role gate only). Without a
 * notification backend (VITE_NOTIFICATION_API_URL unset, or the summary answers 404 / 501)
 * the app's not-found page; `fallback` until the summary first answers.
 */
export function NotificationsGate({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { availability } = useNotificationSummary();
  if (availability === 'absent') return <AccessStatePage state='not_found' />;
  if (availability === 'unknown') return <>{fallback}</>;
  return <>{children}</>;
}
